<app-sidenav-admin></app-sidenav-admin>
  <router-outlet></router-outlet>
<app-footer-admin></app-footer-admin>
